import { object, string, ref } from 'yup';
import PasswordValidation from 'shared/validation/PasswordValidation';
// min 5 characters, 1 upper case letter, 1 lower case letter, 1 numeric digit.

export const Fields = [
  {
    name: 'email',
    placeholder: 'Email',
    label: 'Email',
    disabled: true,
  },
  {
    name: 'createPassword',
    placeholder: 'Create Password',
    label: 'Create Password',
    password: true,
    visibilityToggle: true,
  },
  {
    name: 'confirmPassword',
    placeholder: 'Confirm Password',
    label: 'Confirm Password',
    password: true,
    visibilityToggle: true,
  },
];
export const validationSchema = object({
  email: string().required('Required').email('Enter a valid email address!'),
  createPassword: string().required('Required').matches(PasswordValidation, {
    message:
      'Please create a stronger password with 5 characters, 1 upper case letter, 1 lower case letter, 1 numeric digit',
  }),
  confirmPassword: string()
    .oneOf([ref('createPassword'), undefined], 'Passwords must match')
    .required('Required'),
});
export const initialValues = {
  email: 'example@email.com',
  createpassword: '',
  confirmpassword: '',
};
